//// Accordion (Akkordeon) — mirrors parts/contentblocks/accordion.php.
// Enhances the collapsed boxes into slide-animated panels. The markup is already
// accessible on its own (<button aria-expanded aria-controls> inside an <h3>, with a
// <noscript> style opening every panel when JS is off), so this only wires the toggle
// and animates the reveal. Multiple panels may be open at once. Under reduced-motion we
// skip the slide and let CSS (.is-open) show/hide instantly.

ready(function () {
    var accordions = findAll('.contentblock-accordion');
    if (!accordions.length)
        return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    accordions.forEach(function (accordion) {
        accordion.findAll('.element').forEach(function (element) {
            var button = element.find('.title');
            var panel  = element.find('.text');
            if (!button || !panel)
                return;

            button.on('click', function () {
                var open = element.classList.toggle('is-open');
                this.setAttribute('aria-expanded', open ? 'true' : 'false');

                if (reduceMotion)      // CSS (.is-open > .text) handles display
                    return;

                if (open)
                    panel.slideDown();
                else
                    panel.slideUp();
            });
        });
    });
});
